var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Cookies from "universal-cookie";
import { getSession } from "./utils/auth0";
import { getUserObject } from "./utils/get-user-object";
export const protectedRoute = (options) => {
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        // Parse URL for returnTo and connection parameters
        const [pathname = "/", ...queryParts] = ctx.resolvedUrl.split("?");
        // Don't use auth routes as returnTo to prevent redirect loops
        const isAuthRoute = pathname.startsWith("/api/auth/");
        const returnTo = (_a = options === null || options === void 0 ? void 0 : options.returnTo) !== null && _a !== void 0 ? _a : (!isAuthRoute && pathname.length > 1 ? pathname : "/");
        const connectionParam = queryParts
            .join("&")
            .split("&")
            .find((part) => part.startsWith("connection=") || part.startsWith("conn="));
        const connection = (_b = connectionParam === null || connectionParam === void 0 ? void 0 : connectionParam.split("=")[1]) !== null && _b !== void 0 ? _b : "";
        // V4: getSession() only takes request
        const session = yield getSession(ctx.req);
        // No session - redirect to login
        if (session === null || session === undefined) {
            let loginUrl = `/api/auth/login?returnTo=${encodeURIComponent(returnTo)}`;
            if (connection.length > 0) {
                loginUrl += `&connection=${encodeURIComponent(connection)}`;
            }
            return {
                redirect: {
                    destination: loginUrl,
                    permanent: false,
                },
            };
        }
        const userProps = { props: { user: session.user } };
        const user = getUserObject(session.user);
        let app = undefined;
        let roles = undefined;
        let hasApp = false;
        let hasRole = false;
        if ((options === null || options === void 0 ? void 0 : options.restrictions) !== undefined) {
            let { restrictions } = options;
            if (typeof restrictions === "string") {
                app = restrictions;
            }
            else if (typeof restrictions === "object") {
                ({ app, roles } = restrictions);
            }
            if (app !== undefined) {
                hasApp = user.availableApps.includes(app);
            }
            if (roles !== undefined && app !== undefined) {
                const cookies = new Cookies(ctx.req.headers.cookie);
                let appInfo = user.appInfo[app];
                if (appInfo !== undefined &&
                    "customers" in appInfo &&
                    appInfo.customers.length > 0) {
                    const [firstCustomer] = appInfo.customers;
                    if ((firstCustomer === null || firstCustomer === void 0 ? void 0 : firstCustomer.roles) && firstCustomer.roles.length > 0) {
                        let userRoles = firstCustomer.roles;
                        const customer = cookies.get("customer");
                        if (typeof customer === "string") {
                            const foundCustomer = appInfo.customers.find((c) => c.customerId === customer);
                            if (foundCustomer === null || foundCustomer === void 0 ? void 0 : foundCustomer.roles) {
                                userRoles = foundCustomer.roles;
                            }
                        }
                        hasRole = roles.some((role) => userRoles.includes(role));
                    }
                }
                else {
                    if (appInfo !== undefined &&
                        "roles" in appInfo &&
                        appInfo.roles.length > 0) {
                        const userRoles = appInfo.roles;
                        hasRole = roles.some((role) => userRoles.includes(role));
                    }
                }
            }
            // redirect to host or previous page on host if user doesn't meet restrictions
            const { headers } = ctx.req;
            if ((app !== undefined && !hasApp) || (roles !== undefined && !hasRole)) {
                let redirectUrl = "/";
                if (Object.prototype.hasOwnProperty.call(headers, "referer") &&
                    ((_d = (_c = headers.referer) === null || _c === void 0 ? void 0 : _c.includes(headers.host)) !== null && _d !== void 0 ? _d : false)) {
                    redirectUrl = headers.referer;
                }
                if (options.redirectTo !== undefined) {
                    redirectUrl = options.redirectTo;
                }
                return {
                    redirect: {
                        destination: redirectUrl,
                        permanent: false,
                    },
                };
            }
        }
        return userProps;
    });
};
